import React, { useId } from 'react'
import PropTypes from 'prop-types'

const GoogleLogoIcon = React.forwardRef(function GoogleLogoIcon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.52 12.27C23.52 11.42 23.44 10.6 23.3 9.82001H12V14.46H18.46C18.18 15.96 17.34 17.23 16.07 18.08V21.09H19.95C22.22 19 23.53 15.92 23.53 12.27H23.52Z"
          fill="#3E82F1"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 24C15.24 24 17.96 22.93 19.94 21.09L16.06 18.08C14.99 18.8 13.61 19.23 12 19.23C8.87 19.23 6.23 17.12 5.29 14.28H1.28V17.39C3.25 21.31 7.31 24 12 24Z"
          fill="#32A751"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.29 14.28C5.05 13.56 4.91 12.79 4.91 12C4.91 11.21 5.05 10.44 5.29 9.71999V6.60999H1.28C0.47 8.22999 0 10.06 0 12C0 13.94 0.46 15.77 1.28 17.39L5.29 14.28Z"
          fill="#F9BB00"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4.76999C13.76 4.76999 15.34 5.37999 16.59 6.55999L20.03 3.11999C17.95 1.17999 15.24 -0.0100098 12 -0.0100098C7.31 -9.76585e-06 3.25 2.68999 1.28 6.60999L5.29 9.71999C6.23 6.87999 8.88 4.76999 12 4.76999Z"
          fill="#E74235"
        ></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

GoogleLogoIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

GoogleLogoIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default GoogleLogoIcon
